module.exports = __WEBPACK_EXTERNAL_MODULE_44__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getIsoWeek"],"commonjs":"date-fns/get_iso_week/index","commonjs2":"date-fns/get_iso_week/index","amd":"date-fns/get_iso_week/index"}
// module id = 44
// module chunks = 0